<template>
    
    <section class="drawer">
        <!-- <section class="drawer" v-if="triggered"> -->
        <div class="drawer-menu">
            <svg viewBox="0 0 9.53 7.33"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><polygon class="cls-1" points="4.53 6.46 1.73 3.66 4.53 0.86 3.66 0 0 3.66 3.66 7.33 4.53 6.46"/><polygon class="cls-1" points="9.53 6.46 6.73 3.66 9.53 0.86 8.66 0 5 3.66 8.66 7.33 9.53 6.46"/></g></g></svg>
            <span @click="drawerOpen = !drawerOpen">
                Free HIV Test
            </span>
        </div>
        <div v-if="drawerOpen" class="container">
            <div class="columns">
                <div class="column is-6 is-offset-3">
                    <div class="drawer-content">
                        <div>
                            <!-- <span class="pop-close" @click="triggeredFalse">
                                <svg viewBox="0 0 26 26" fill="none" role="img" class="icon fill-current">
                                <path d="M8.28596 6.51819C7.7978 6.03003 7.00634 6.03003 6.51819 6.51819C6.03003 7.00634 6.03003 7.7978 6.51819 8.28596L11.2322 13L6.51819 17.714C6.03003 18.2022 6.03003 18.9937 6.51819 19.4818C7.00634 19.97 7.7978 19.97 8.28596 19.4818L13 14.7678L17.714 19.4818C18.2022 19.97 18.9937 19.97 19.4818 19.4818C19.97 18.9937 19.97 18.2022 19.4818 17.714L14.7678 13L19.4818 8.28596C19.97 7.7978 19.97 7.00634 19.4818 6.51819C18.9937 6.03003 18.2022 6.03003 17.714 6.51819L13 11.2322L8.28596 6.51819Z" fill="currentColor"></path>
                                </svg>
                            </span> -->
                            <h1 v-if="title" class="page-title">{{ title }}</h1>
                            <div v-html="description" class="short-description"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script>
    import sharedMethodsMixin from '@/mixins/sharedMethodsMixin'
    import { resources } from '@/utils/constants'
    export default {
        name: "Drawer",
        mixins: [sharedMethodsMixin],
        props: [ ],
        data() {
            return {
                //isActive: this.$route.path,
                drawerOpen: false,
                isSubmitted: false,
                title: 'Free HIV Test',
                description: '<p>The only way to know for sure if you have HIV is to get tested. You can’t tell if you have HIV just by the way you feel, because most people who get HIV don’t have any symptoms for years. Luckily, HIV testing is pretty easy and painless and now you can do it for free! </p><br><p>If you woudl like to make an appointment to get tested please contact one of the members of IDI’s team: <b>Ruth Nalunga at 0751051866 and/or  Olivia Namusoke at 0779 452176</b></p>',
                email: '',
                emailValid: true,
                phoneNumber: '',
                phoneNumberValid: true
            }
        },
        mounted() {
            
        },
        methods: {
            
        }
    }
</script>
